import React from 'react';
import Navigation from '../components/static/Navigation';
import Footer from '../components/static/Footer';
import VBInput from '@vb-js-commons/new/vbInput';
import VBTextarea from '@vb-js-commons/new/vbTextarea';
import { validateEmail } from '../api';
import { TwModal } from '@ui-component-library';
import Cookies from 'js-cookie';

class ContactSellerPage extends React.Component {
    constructor() {
        super();
        this.state = {
            formData: {},
            errors: {},
            messageSentModal: false,
            reloadForm: false
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        let data = this.state.formData
        data.ad_id = Window.react_data.ad_id
        let validation = {}

        if (!data.name) {
            validation.name = "Du har inte angett ditt namn."
        }
        if ((!data.email || !validateEmail(data.email))) {
            validation.email = "Den här e-postadressen ser inte ut att vara korrekt";
        }
        if (!data.message) {
            validation.message = "Du har inte skrivit ditt meddelande"
        }
        if (Object.keys(validation).length !== 0) {
            this.setState({ errors: validation })
        }
        else {
            try {
                let target = "/contact-seller/"

                fetch(target, {
                    "method": "POST",
                    "body": JSON.stringify({ "data": data }),
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRFToken': Cookies.get('csrftoken')
                    },
                }).then(res => {
                    if (res.ok) {
                        this.setState({ messageSentModal: true, reloadForm: true })
                    } else {
                        alert('Oops! Något gick fel...')
                    }
                });
            } catch (error) {
                alert('Oops! Något gick fel...')
            }
        }
    }


    render() {
        return (<div className="w-full p-0">
            <div className="bg-white">
                <Navigation />
                
                <div className='bg-white'>
                    <section className='container charcoal'>
                        <div className='flex flex-wrap justify-center'>
                            <div className='w-full md:w-5/6 lg:w-2/3'>
                                <h1 className="mb-6 flex justify-center">Kontakta säljaren</h1>

                                <h2 className='flex justify-center'>Skicka ett meddelande</h2>

                                {!this.state.reloadForm &&
                                    <form onSubmit={(e) => this.handleSubmit(e)}>
                                        <div className="flex flex-wrap justify-center">
                                            <div className='mb-2'>
                                                <VBInput
                                                    type="text"
                                                    placeholder="Namn"
                                                    label={<label className='pb-1'>Ditt namn</label>}
                                                    error={this.state.errors.name}
                                                    onChange={(val) => { this.setState({ formData: { ...this.state.formData, name: val } }); }} />
                                            </div>
                                            <div className='mb-2'>
                                                <VBInput
                                                    type="email"
                                                    placeholder="Email"
                                                    label={<label className='pb-1'>Din email</label>}
                                                    error={this.state.errors.email}
                                                    onChange={(val) => { this.setState({ formData: { ...this.state.formData, email: val } }); }} />
                                            </div>
                                            <div className='mb-2'>
                                                <VBTextarea
                                                    type="text"
                                                    rows={8}
                                                    label={<label className='pb-1'>Ditt fråga</label>}
                                                    error={this.state.errors.message}
                                                    onChange={(val) => { this.setState({ formData: { ...this.state.formData, message: val } }); }} />
                                            </div>
                                            <div className="flex justify-center mt-6">
                                                <button type="submit" className='n-btn btn-forest-green'>Skicka fråga</button>
                                            </div>
                                        </div>
                                    </form>
                                }

                                <TwModal isOpen={this.state.messageSentModal} className="bg-neutral-charcoal">
                                    <TwModal.Header>
                                        <div className="flex justify-between items-start">
                                            <h2 className="primary-main mb-0">Skickat</h2>
                                            <button type="button" className="ml-auto fs-5 leading-none white" onClick={() => this.setState({ messageSentModal: false, formData: {}, reloadForm: false })} aria-label="Close">&times;</button>
                                        </div>
                                    </TwModal.Header>
                                    <TwModal.Content>
                                        <p className="white mb-0">Ditt meddelande skickas och vi kontaktar dig inom kort.</p>
                                    </TwModal.Content>
                                    <TwModal.Footer>
                                        <div className="flex justify-end">
                                            <button className="n-btn btn-sm" onClick={() => this.setState({ messageSentModal: false, formData: {}, reloadForm: false })}>Stäng</button>
                                        </div>
                                    </TwModal.Footer>
                                </TwModal>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>

        </div>)
    }
}
export default ContactSellerPage;